import React from "react";
import { CURD } from "../curd.operation";

const SatsangiRegistrationPublic: React.FC = () => {
  // Optionally, you can pass props to CURD if needed to indicate "add" mode
  return <CURD />;
};

export default SatsangiRegistrationPublic;
